<template>
    <v-container class="margen">
        <v-row>
            <v-col cols="12">
                <v-stepper v-model="paso">
                  <v-stepper-header>
                    <v-stepper-step :complete="paso > 1" editable edit-icon="fas fa-check" step="1">{{$t('Carrito.Productos')}}</v-stepper-step>
                    <v-divider />
                    <v-stepper-step :complete="paso > 2" :editable="pasoCompletado > 1" edit-icon="fas fa-check" step="2">{{$t('Carrito.Envio')}}</v-stepper-step>
                    <v-divider />
                    <v-stepper-step :complete="paso > 3" :editable="pasoCompletado > 2" edit-icon="fas fa-check" step="3">{{$t('Carrito.Pago')}}</v-stepper-step>
                    <v-divider />
                    <v-stepper-step :complete="paso > 4" :editable="pasoCompletado > 3" edit-icon="fas fa-check" step="4">{{$t('Carrito.Resumen')}}</v-stepper-step>
                  </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                          <v-container>
                            <v-row>
                                <v-col>
                                    <v-data-iterator :items="getProductos" disable-pagination disable-filtering disable-sort hide-default-footer no-data-text="">
                                        <template v-slot:default="props">
                                            <v-row v-for="(i, index) in props.items" :key="i.uid" align="center">
                                                <v-col cols="12" xs="12" sm="4" md="4">
                                                    <v-img :src="i.imagenPrincipal" aspect-ratio="1"/>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="6" md="6" style="padding-left:60px;">
                                                    <h3 class="title font-weight-bold">{{i.titulo.toUpperCase()}}</h3>
                                                    <h4 class="subtitle-1 font-weight-regular pb-5" v-if="i.artista">{{i.artista.nombre}}</h4>
                                                    <p class="mb-1" v-if="i.subcategoria"><b>{{$t('Formularios.Categoria')}}</b>: {{i.subcategoria}}</p>
                                                    <p class="mb-1" v-if="i.talla && i.tipo === 'fisico'"><b>{{$t('Oficina.Talla')}}</b>: {{i.talla}}</p>
                                                    <p class="mb-1" v-if="i.color && i.tipo === 'fisico'"><b>{{$t('Oficina.Color')}}</b>: {{i.color}}</p>
                                                    <p class="mb-1" v-if="i.dimensiones"><b>{{$t('Formularios.Dimensiones')}}</b>: {{ $t('Busqueda.Largo')}} {{ i.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.alto }}cm</p>
                                                    <p class="mb-1" v-if="i.dimensiones"><b>{{$t('Busqueda.PesoNormal')}}</b>: {{i.dimensiones.peso}} gr</p>

                                                    <div v-if="i.tipo === 'fisico'">
                                                      <div v-if="i.dimensiones && !i.dimensionesEnrollado">
                                                        <h3 class="mt-4 mb-2 font-weight-bold">{{$t('Formularios.MedidasEmpacado')}}</h3>
                                                        <p class="mb-1 ml-2"><b>{{$t('Formularios.Dimensiones')}}</b>: {{ $t('Busqueda.Largo')}} {{ i.dimensiones.largoEmpacado }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.anchoEmpacado }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.altoEmpacado }}cm</p>
                                                        <p class="mb-2 ml-2"><b>{{$t('Busqueda.PesoNormal')}}</b>: {{i.dimensiones.pesoEmpacado}} gr</p>
                                                      </div>
                                                      <!-- <span style="font-size:15px;color:#bdbdbd;" v-if="i.dimensiones">{{ $t('Busqueda.Largo')}} {{ i.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.alto }}cm</span> -->
                                                      <div v-if="i.dimensionesEnrollado">
                                                        <h3 class="mt-4 mb-2 font-weight-bold">{{$t('Formularios.MedidasComoEmpacar')}}</h3>

                                                        <div v-if="i.dimensiones">
                                                          <v-checkbox v-model="i.normal" :label="$t('Formularios.ObraBastidor')" @change="empaqueNormal(index)"/>
                                                          <p class="mb-1 ml-2"><b>{{$t('Formularios.Dimensiones')}}</b>: {{ $t('Busqueda.Largo')}} {{ i.dimensiones.largoEmpacado }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.anchoEmpacado }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.altoEmpacado }}cm</p>
                                                          <p class="mb-2 ml-2"><b>{{$t('Busqueda.PesoNormal')}}</b>: {{i.dimensiones.pesoEmpacado}} gr</p>
                                                        </div>
                                                        <div v-if="i.dimensionesEnrollado && i.dimensionesEnrollado.pesoEmpacado && i.dimensionesEnrollado.largoEmpacado && i.dimensionesEnrollado.anchoEmpacado &&  i.dimensionesEnrollado.altoEmpacado" >
                                                          <v-checkbox v-model="i.enrollado" :label="$t('Formularios.ObraEnrollada')" @change="empaqueEnrollado(index)"/>
                                                          <p class="mb-1 ml-2"><b>{{$t('Formularios.DimensionesEnrollado')}}</b>: {{ $t('Busqueda.Largo')}} {{ i.dimensionesEnrollado.largoEmpacado }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensionesEnrollado.anchoEmpacado }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensionesEnrollado.altoEmpacado }}cm</p>
                                                          <p class="mb-1 ml-2"><b>{{$t('Busqueda.PesoEnrollado')}}</b>: {{i.dimensionesEnrollado.pesoEmpacado}} gr</p>
                                                          <span class="pt-3 ml-2" style="font-size:17px;color:#a0a0a0;" >*Este empaquetado podría reducir el costo del envío</span>
                                                        </div>
                                                      </div>
                                                      <!-- Pasar la variable enrollado para validaciones -->
                                                    </div>
                                                    <p v-if="i.tipo === 'digital'">{{$t('Formularios.Digital')}}</p>
                                                    <template v-if="i.tipo === 'tour'">
                                                      <p class="mb-0"><b>{{$t('Carrito.Fecha')}}</b>: {{i.fecha}}</p>
                                                      <p class="mb-0"><b>{{$t('Carrito.Horario')}}</b>: {{i.horario}}</p>
                                                      <p class="mb-0"><b>{{$t('Carrito.Pasajeros')}}</b>: {{i.pasajeros}}</p>
                                                      <p class="mb-5"><b>{{$t('Carrito.Preferencias')}}</b>:</p>
                                                      <v-chip v-for="i in i.preferencias" :key="i" color="primary" class="mx-2">{{i}}</v-chip>
                                                    </template>
                                                    <template v-if="i.tipo === 'giftcard'">
                                                      <p class="mb-0"><b>{{$t('Regalo.De')}}</b>: {{i.regalo.comprador}}</p>
                                                      <p class="mb-0"><b>{{$t('Regalo.Para')}}</b>: {{i.regalo.nombre}}</p>
                                                      <p class="mb-0"><b>{{$t('Regalo.IdiomaRecibe')}}</b>: {{$t(`Regalo.${i.regalo.idioma}`)}}</p>
                                                      <p class="mb-0"><b>{{$t('Regalo.Msj')}}</b>: {{i.regalo.mensaje}}</p>
                                                    </template>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="2" md="2" align="center">
                                                    <p @click="unSetProducto(index)" class="primary--text mb-5 pb-5" style="cursor:pointer">{{$t('Carrito.Remover')}}<v-icon class="ml-2" size="16px">fas fa-trash-alt</v-icon></p>
                                                    <template v-if="i.tipo === 'fisico'">
                                                      <p class="black--text subtitle" v-if="getMoneda === 'COP'">${{Number(i.totalProducto).toLocaleString()}}</p>
                                                      <p class="black--text subtitle" v-else>${{ Math.round((i.totalProducto)/getDolar)}}</p>
                                                      <v-icon @click="disminuirCantidad(index)" size="14" color="black">fas fa-minus</v-icon>
                                                      <span class="black--text mx-2">{{i.cantidad}}</span>
                                                      <v-icon @click="aumentarCantidad(index)" size="14" color="black">fas fa-plus</v-icon>
                                                    </template>
                                                    <template v-if="i.tipo === 'digital'">
                                                      <p class="black--text subtitle" v-if="getMoneda === 'COP'">${{Number(i.totalProducto).toLocaleString()}}</p>
                                                      <p class="black--text subtitle" v-else>${{ Math.round(i.totalProducto/getDolar)}}</p>
                                                      <v-icon @click="disminuirCantidad(index)" size="14" color="black">fas fa-minus</v-icon>
                                                      <span class="black--text mx-2">{{i.cantidad}}</span>
                                                      <v-icon @click="aumentarCantidad(index)" size="14" color="black">fas fa-plus</v-icon>
                                                    </template>
                                                    <template v-if="i.tipo === 'tour' || i.tipo === 'giftcard'">
                                                      <p class="black--text subtitle" v-if="getMoneda === 'COP'">${{Number(i.precio).toLocaleString()}}</p>
                                                      <p class="black--text subtitle" v-else>${{ Math.round(i.precio/getDolar)}}</p>
                                                    </template>
                                                </v-col>
                                                <v-col cols="12" class="ma-0 pa-0">
                                                    <v-divider />
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-data-iterator>
                                </v-col>
                                <v-col cols="12" align="center" v-if="getProductos[0] !== undefined">
                                    <v-row>
                                        <v-col cols="12" xs="12" md="9">
                                            <v-text-field v-model="codigo" class="mx-2 mb-0 pb-0" solo :label="$t('Carrito.CodigoPromocional')" :hint="$t('Carrito.CodigoPromocional')" persistent-hint></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="3">
                                            <v-btn outlined color="primary" x-large style="border:3px solid;font-weight:bold;" @click="aplicarCupon()" class="mt-0 pt-0">{{$t('Carrito.Aplicar')}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" align="center" class="pb-0" v-if="descuento || porcentaje">
                                    <h2 v-if="getMoneda === 'COP'" class="font-weight-light title">Subtotal: ${{ getSubtotal.toLocaleString() }}</h2>
                                    <h2 v-else class="font-weight-light title">Subtotal: ${{ Math.round(getSubtotal/getDolar).toLocaleString() }}</h2>
                                </v-col>
                                <v-col cols="12" align="center" class="py-0" v-if="descuento">
                                    <h2 v-if="getMoneda === 'COP'" class="font-weight-light title">{{$t('Carrito.Descuento')}}: ${{ Number(descuento).toLocaleString() }}</h2>
                                    <h2 v-else class="font-weight-light title">{{$t('Carrito.Descuento')}}: ${{ Math.round(descuento/getDolar).toLocaleString() }}</h2>
                                </v-col>
                                <v-col cols="12" align="center" class="py-0" v-if="porcentaje">
                                    <h2 class="font-weight-light title">{{$t('Carrito.Descuento')}}: {{porcentaje}}%</h2>
                                </v-col>
                                <v-col cols="12" align="center" class="pt-0"  v-if="getProductos[0] !== undefined">
                                    <h2 v-if="getMoneda === 'COP' && getTotal > 0" class="font-weight-light title">Total: ${{ getTotal.toLocaleString() }}</h2>
                                    <h2 v-if="getMoneda === 'USD' && getTotal > 0" class="font-weight-light title">Total: ${{ Math.round(getTotal/getDolar).toLocaleString() }}</h2>
                                    <h2 v-if="getMoneda === 'COP' && getTotal < 0" class="font-weight-light title">{{$t('Formularios.Cupon')}}: ${{ Math.abs(getTotal).toLocaleString() }}</h2>
                                    <h2 v-if="getMoneda === 'USD' && getTotal < 0" class="font-weight-light title">{{$t('Formularios.Cupon')}}: ${{ Math.abs(Math.round(getTotal/getDolar)).toLocaleString() }}</h2>
                                    <h2 v-if="getTotal < 0" class="font-weight-light title">Total: $0</h2>
                                    <span v-if="getTotal < 0">Se te generará un cupón nuevo con el dinero restante</span>
                                </v-col>
                                <v-col cols="12" v-if="getProductos[0] !== undefined" align="center">
                                    <v-btn color="primary white--text" x-large style="min-width:20%!important" @click="seccionLlena(2)" :disabled="!getCarritoHabilitado">{{$t('Carrito.Continuar')}}</v-btn>
                                    <h3 class="mt-3" v-if="!getCarritoHabilitado">La compras se encuentras deshabilitadas temporalmente</h3>
                                </v-col>
                            </v-row>
                          </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-container>
                            <v-form v-model="valido">
                              <v-row name="Identificacion" v-if="!getLogeado">
                                  <v-col cols="12" align="center">
                                      <h2>{{$t('Carrito.IniciaSesion')}}</h2>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <v-btn :outlined="cliente" :text="!cliente" x-large class="ma-2" @click="cliente = true" :color="cliente ? 'black' : ''">{{ $t('Carrito.Acceso') }}</v-btn>
                                      <v-btn :outlined="!cliente" :text="cliente" x-large class="ma-2" @click="cliente = false" :color="!cliente ? 'black' : ''">{{ $t('Carrito.Registro') }}</v-btn>
                                  </v-col>
                                  <v-col cols="12" name="Acceso" v-if="cliente">
                                      <v-row>
                                          <v-col cols="12">
                                              <v-text-field class="mx-2" solo v-model="acceso.email" :label="$t('Carrito.Correo')" :hint="$t('Formularios.Email')" :rules="[v => !!v || $t('Formularios.EmailRequerido')]" persistent-hint required/>
                                          </v-col>
                                          <v-col cols="12">
                                              <v-text-field class="mx-2" solo v-model="acceso.contrasena" :label="$t('Carrito.Contrasena')" :hint="$t('Formularios.Contrasena')" :rules="[v => !!v || $t('Formularios.ContrasenaRequerido')]" type="password" persistent-hint required/>
                                          </v-col>
                                          <v-col cols="12" align="center">
                                              <v-btn color="primary white--text" style="min-width:20%!important" x-large @click="iniciarSesion(acceso)">{{$t('Carrito.IniciarSesion')}}</v-btn>
                                          </v-col>
                                      </v-row>
                                  </v-col>
                                  <v-col cols="12" name="Registro" v-else>
                                      <v-row>
                                          <v-col cols="12">
                                              <v-text-field class="mx-2" solo v-model="registro.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" :rules="[v => !!v || $t('Formularios.NombreRequerido')]" persistent-hint required/>
                                          </v-col>
                                          <v-col cols="12">
                                              <v-text-field class="mx-2" solo v-model="registro.email" :label="$t('Carrito.Correo')" :hint="$t('Carrito.Correo')" :rules="emailRules" persistent-hint required />
                                          </v-col>
                                          <v-col cols="12">
                                              <v-text-field class="mx-2" solo v-model="registro.contrasena" :label="$t('Carrito.Contrasena')" :hint="$t('Formularios.Contrasena')" :rules="passwordRules" type="password" persistent-hint required/>
                                          </v-col>
                                          <v-col cols="12">
                                              <v-text-field class="mx-2" persistent-hint solo v-model="registro.telefono" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')"/>
                                          </v-col>
                                          <v-col cols="12">
                                              <v-checkbox class="mx-2" v-model="registro.newsletter" :label="$t('Formularios.Newsletter')" :hint="$t('Formularios.Newsletter')" color="primary"/>
                                          </v-col>
                                          <v-col cols="12" align="center">
                                              <v-btn :disabled="!valido" color="primary white--text" style="min-width:20%!important" x-large @click="registroCliente(registro)">{{$t('Carrito.Registrarse')}}</v-btn>
                                          </v-col>
                                      </v-row>
                                  </v-col>
                              </v-row>
                              <v-row name="Informacion" v-else>
                                  <v-col cols="12">
                                      <h2>{{$t('Carrito.DireccionDeEnvio')}}</h2>
                                  </v-col>
                                  <!-- Regalo -->
                                  <v-col cols="12">
                                    <v-switch v-model="esRegalo" :label="$t('Formularios.EsRegalo')"></v-switch>
                                  </v-col>
                                  <template v-if="esRegalo">
                                    <v-col cols="12">
                                      <h2>{{$t('Formularios.DireccionRegalo')}}</h2>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="regalo.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                        <v-text-field class="mx-2" solo persistent-hint v-model="regalo.telefono" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="regalo">
                                        <v-autocomplete class="mx-2" solo persistent-hint :items="getPaises" item-text="name" item-value="id" v-model="regalo.pais" :label="$t('Formularios.Pais')" :hint="$t('Formularios.Pais')" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="regalo.pais">
                                        <v-autocomplete class="mx-2" solo persistent-hint :items="Object.keys(getPaises[regalo.pais - 1].states)" v-model="regalo.departamento" :label="$t('Formularios.Departamento')" :hint="$t('Formularios.Departamento')" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="regalo.departamento">
                                        <v-text-field class="mx-2" solo persistent-hint v-model="regalo.ciudad" :label="$t('Formularios.Ciudad')" :hint="$t('Formularios.Ciudad')" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="regalo.ciudad">
                                        <v-text-field class="mx-2" solo persistent-hint v-model="regalo.direccion" :label="$t('Formularios.Direccion')" :hint="$t('Formularios.Direccion')" required/>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                        <v-text-field class="mx-2" solo persistent-hint v-model="regalo.codigoPostal" :label="$t('Formularios.CodigoPostal')" :hint="$t('Formularios.CodigoPostal')" />
                                    </v-col>
                                    <v-col cols="12">
                                      <v-divider />
                                    </v-col>
                                  </template>
                                  <!-- Informacion Cliente -->
                                  <v-col cols="12" v-if="esRegalo">
                                    <h2>{{$t('Formularios.DireccionComprador')}}</h2>
                                  </v-col>

                                  <template v-if="usuario">
                                    <v-col cols="12" xs="12" md="6">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                      <v-select class="mx-2" solo persistent-hint v-model="usuario.tipoDocumento" :items="tiposDocumento" :label="$t('PayU.TipoDeDocumento')" :hint="$t('PayU.TipoDeDocumento')" item-text="titulo" item-value="id" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.documento" :label="$t('PayU.NumeroDeDocumento')" :hint="$t('PayU.NumeroDeDocumento')" type="number" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.telefono" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="usuario">
                                      <v-autocomplete class="mx-2" solo persistent-hint :items="getPaises" item-text="name" item-value="id" v-model="usuario.pais" :label="$t('Formularios.Pais')" :hint="$t('Formularios.Pais')" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="usuario.pais">
                                      <v-autocomplete class="mx-2" solo persistent-hint :items="Object.keys(getPaises[usuario.pais - 1].states)" v-model="usuario.departamento" :label="$t('Formularios.Departamento')" :hint="$t('Formularios.Departamento')" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="usuario.departamento">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.ciudad" :label="$t('Formularios.Ciudad')" :hint="$t('Formularios.Ciudad')" :rules="requerido" />
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" v-if="usuario.ciudad">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.direccion" :label="$t('Formularios.Direccion')" :hint="$t('Formularios.Direccion')" :rules="requerido"/>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6">
                                      <v-text-field class="mx-2" solo persistent-hint v-model="usuario.codigoPostal" :label="$t('Formularios.CodigoPostal')" :hint="$t('Formularios.CodigoPostal')" :rules="requerido" />
                                    </v-col>
                                  </template>

                                  <div v-for="i in getProductos" :key="i.uid">
                                    <div v-if="i.envioIncluido" >
                                      <v-col cols="12" md="12" >
                                          <span class="grey--text">{{$t('Carrito.EnvioGratis')}}</span>
                                      </v-col>
                                    </div>
                                    <div v-else>
                                    <!-- <v-col cols="12" md="12" >
                                        <span class="grey--text">ENVIO TIENE UN COSTE</span>
                                    </v-col> -->
                                    </div>
                                  </div>
                                  <v-col cols="12" align="center" class="mt-5">
                                    <v-btn color="primary white--text" style="min-width:20%!important" x-large :disabled="!valido" @click="calcularCostosEnvio">{{$t('Carrito.CalcularCosto')}}</v-btn>
                                  </v-col>
                              </v-row>
                            </v-form>
                            <div v-if="costosEnvio">
                              <v-row v-for="item in productosEmail" :key="item.email">
                                <v-col cols="12" >
                                  <h3 class="title font-weight-bold">{{item.nombre}}</h3>
                                </v-col>
                                <v-col cols="6" xs="12" v-for="i in item.productos" :key="i.uid" >
                                  <v-row align="center">
                                    <v-col cols="6" xs="4" md="2" class="" align="center">
                                      <v-img :src="i.imagenPrincipal" aspect-ratio="1"/>
                                    </v-col>
                                    <v-col cols="6" xs="12" md="3" class="px-5" align="center">
                                      <h4 class="subtitle-1 font-weight-regular pb-1">{{i.titulo.toUpperCase()}}</h4>
                                      <p class="mb-1" v-if="i.cantidad"><b>{{$t('Formularios.Cantidad')}}:</b> {{i.cantidad}}</p>
                                    </v-col>

                                    <v-col cols="6" xs="12" md="3" class="px-5" align="center">
                                      <p class="mb-1" v-if="i.precio && getMoneda === 'COP' "><b>{{$t('Formularios.PrecioUnitario')}}:</b> ${{Number(i.precio).toLocaleString()}}</p>
                                       <!-- <p class="black--text subtitle" v-if="getMoneda === 'COP'">${{Number(i.totalProducto).toLocaleString()}}</p> -->
                                      <p class="black--text subtitle" v-else><b>{{$t('Formularios.PrecioUnitario')}}:</b>${{ Math.round((i.precio)/getDolar)}}</p>
                                    </v-col>
                                    <v-col cols="6" xs="12" md="3" class="px-5" align="center">
                                      <p class="mb-1" v-if="i.totalProducto  && getMoneda === 'COP'"><b>{{$t('Formularios.PrecioTotal')}}:</b> ${{Number(i.totalProducto).toLocaleString()}}</p>
                                      <p class="black--text subtitle" v-else><b>{{$t('Formularios.PrecioUnitario')}}:</b>${{ Math.round((i.totalProducto)/getDolar)}}</p>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="12" class="px-5" align="center">

                                  <h3 v-if="getMoneda === 'COP'"><b>{{$t('Email.CosteEnvio')}}:</b> $ {{item.costoEnvio.toLocaleString()}}</h3>
                                   <h3 v-else><b>{{$t('Email.CosteEnvio')}}:</b>$ {{ Math.round(item.costoEnvio)}}</h3>
                                </v-col>

                                <v-col cols="12" class="ma-0 pa-0">
                                  <v-divider />
                                </v-col>
                              </v-row>

                              <div v-if="!errorEnvio" class="mt-2">

                                <v-col cols="12" align="center" class="pb-2" v-if="usuario.ciudad">
                                  <h2 v-if="getMoneda === 'COP' && getTotal > 0" class="font-weight-light title">Subtotal: ${{ getTotal.toLocaleString() }}</h2>
                                  <h2 v-if="getMoneda === 'USD' && getTotal > 0" class="font-weight-light title">Subtotal: ${{ Math.round(getTotal/getDolar).toLocaleString() }}</h2>
                                  <h2 v-if="getTotal < 0" class="font-weight-light title">Subtotal: $0</h2>
                                </v-col>

                                <v-col cols="12" align="center" class="py-2" v-if="usuario.ciudad">
                                    <h2 v-if="getMoneda === 'COP'" class="font-weight-light title">{{$t('Carrito.Envio')}}: ${{envio.toLocaleString() }}</h2>
                                    <h2 v-else class="font-weight-light title">{{$t('Carrito.Envio')}}: ${{ Math.round(envio).toLocaleString() }}</h2>
                                </v-col>

                                <v-col cols="12" align="center" class="pt-2" v-if="usuario.ciudad">
                                    <h2 v-if="getMoneda === 'COP' && granTotal > 0" class="font-weight-light title">Total: ${{ granTotal.toLocaleString() }}</h2>
                                    <h2 v-if="getMoneda === 'USD' && granTotal > 0" class="font-weight-light title">Total: ${{ Math.round(granTotal).toLocaleString() }}</h2>
                                    <h2 v-if="getTotal < 0" class="font-weight-light title">Total: $0</h2>
                                </v-col>
                                <v-col cols="12" align="center" class="pt-2" v-if="usuario.ciudad">
                                    <h2 v-if="getMoneda === 'COP' && granTotal < 0" class="font-weight-light title">{{$t('Formularios.Cupon')}}: ${{ Math.abs(granTotal).toLocaleString() }}</h2>
                                    <h2 v-if="getMoneda === 'USD' && granTotal < 0" class="font-weight-light title">{{$t('Formularios.Cupon')}}: ${{ Math.abs(Math.round(granTotal/getDolar)).toLocaleString() }}</h2>
                                    <span v-if="getTotal < 0">Se te generará un cupón nuevo con el dinero restante</span>
                                </v-col>
                                <v-col cols="12" align="center" class="mt-5">
                                    <v-btn color="primary white--text" style="min-width:20%!important" x-large @click="seccionLlena(3)">{{$t('Carrito.Continuar')}}</v-btn>
                                </v-col>
                              </div>
                              <div v-else>
                                <v-col cols="12" align="center" class="pb-2">
                                  <h2 class="font-weight-light title">Error a la hora de obtener los costos de envío</h2>
                                </v-col>
                              </div>
                            </div>
                          </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                          <v-container>
                            <v-row>
                                <v-col cols="12" class="py-0" v-if="granTotal > 0">
                                  <v-autocomplete outlined :label="$t('Formularios.MedioDePago')" :items="mediosDePago" item-text="titulo" item-value="id" v-model="medioDePago" />
                                </v-col>
                                <v-col cols="12" align="center" v-else>
                                  <v-btn @click="pagarCupon()" x-large color="primary white--text">{{$t('Carrito.Continuar')}}</v-btn>
                                </v-col>
                                <v-col cols="12" align="center" v-if="medioDePago === 'payu'">
                                  <v-btn color="primary white--text" style="min-width:20%!important" x-large @click="pagarPayu()">{{$t('Carrito.Pagar')}}</v-btn>
                                </v-col>
                                <v-col cols="12" align="center" v-if="medioDePago === 'paypal'" style="margin-top: 50px;">
                                  <span class="headline" v-if="cargandoPago && !pagoFinalizado">Estamos terminando de procesar tu pago, espera un momento</span>
                                  <v-progress-linear v-if="cargandoPago && !pagoFinalizado" indeterminate />
                                  <span class="headline" v-if="pagoFinalizado">Hemos procesado tu pago correctamente</span>
                                  <br>
                                  <v-btn :loading="cargandoPago && !pagoFinalizado" text color="black" x-large />
                                  <br>
                                  <div ref="paypal" v-if="!cargandoPago && !pagoFinalizado"></div>
                                </v-col>
                            </v-row>
                          </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                          <v-container>
                            <v-row v-if="resumenCompra">
                              <v-col cols="12" align="center">
                                <h2 v-if="medioDePago === 'paypal' || medioDePago === 'cupon' || $route.query.message === '4'">{{$t('Carrito.Aprobado')}}</h2>
                                <h2 v-else-if="$route.query.message === '6'">{{ $t('Carrito.Rechazado') }}</h2>
                                <h2 v-else-if="$route.query.message === '7'">{{ $t('Carrito.Pendiente') }}</h2>
                              </v-col>
                              <v-col cols="12" v-if="medioDePago === 'payu' && pagoFinalizado">
                                <v-row v-if="resumenCompra[0]">
                                  <v-col cols="12" align="center" class="mb-5" style="text-transform: uppercase">
                                      <h2>{{ $t('Carrito.ResumenCompra') }}</h2>
                                  </v-col>
                                  <v-col cols="12" align="center" class="mb-5">
                                    <h3>{{resumenCompra[0].uidPago}}</h3>
                                    <span>{{resumenCompra[0].fecha}}</span>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <v-icon v-if="resumenCompra[0].esRegalo" size="46" color="primary">fas fa-gift</v-icon>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6" class="px-5" align="center">
                                      <v-row>
                                          <v-col cols="12">
                                              <h2 class="font-weight-regular">{{$t('Formularios.Comprador')}}</h2>
                                          </v-col>
                                          <v-col cols="12" style="word-break:break-word;">
                                              <span>{{resumenCompra[0].comprador.nombre}}</span>
                                              <br>
                                              <span>{{resumenCompra[0].comprador.tipoDocumento}} {{resumenCompra[0].comprador.documento}}</span>
                                              <br>
                                              <span>{{getPaises[resumenCompra[0].comprador.pais - 1].name}} - {{resumenCompra[0].comprador.departamento}} - {{resumenCompra[0].comprador.ciudad}}</span>
                                              <br>
                                              <span>{{resumenCompra[0].comprador.direccion}} - {{resumenCompra[0].comprador.codigoPostal}}</span>
                                              <br>
                                              <span>{{resumenCompra[0].comprador.email}}</span>
                                              <br>
                                              <span>{{resumenCompra[0].comprador.telefono}}</span>
                                          </v-col>
                                      </v-row>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6" class="px-5" align="center">
                                    <v-row>
                                        <v-col cols="12">
                                            <h2 class="font-weight-regular">{{$t('Formularios.DireccionEntrega')}}</h2>
                                        </v-col>
                                        <v-col cols="12" style="word-break:break-word;">
                                            <span>{{resumenCompra[0].direccion.nombre}}</span>
                                            <br>
                                            <span>{{getPaises[resumenCompra[0].direccion.pais - 1].name}} - {{resumenCompra[0].direccion.departamento}} - {{resumenCompra[0].direccion.ciudad}}</span>
                                            <br>
                                            <span>{{resumenCompra[0].direccion.direccion}} - {{resumenCompra[0].direccion.codigoPostal}}</span>
                                            <br>
                                            <span>{{resumenCompra[0].direccion.telefono}}</span>
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <h2 class="font-weight-regular">{{$t('Carrito.Productos')}}</h2>
                                  </v-col>
                                  <v-col cols="12" v-for="i in resumenCompra[0].productos" :key="i.uid">
                                      <v-card>
                                          <v-card-title>
                                              <v-container>
                                                  <v-row>
                                                      <v-col cols="4" align-self="center">
                                                          <v-img :src="i.producto.imagenPrincipal" />
                                                      </v-col>
                                                      <v-col cols="8" align-self="center">
                                                          <span>{{i.producto.titulo}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Cantidad')}}:</b> {{i.producto.cantidad}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Tipo')}}:</b> {{i.producto.tipo}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Precio')}}:</b> {{i.total.toLocaleString()}}</span>
                                                          <hr>
                                                          <span><b>{{$t('Formularios.Artista')}}</b></span>
                                                          <br>
                                                          <span>{{i.artista.nombre}}</span>
                                                          <br>
                                                          <span>{{i.artista.email}}</span>
                                                          <br>
                                                          <span>{{i.artista.pais}}</span>
                                                      </v-col>
                                                  </v-row>
                                                  <v-row>
                                                    <v-col cols="12" align="center" v-if="i.producto.tipo === 'fisico'">
                                                      <v-icon color="black" size="42" v-if="i.producto.enviado">fas fa-shipping-fast</v-icon>
                                                      <v-icon color="black" size="42" v-else>fas fa-box-open</v-icon>
                                                      <br>
                                                      <span class="font-weight-bold" v-if="i.producto.enviado">{{$t('Formularios.ProductoEnviado')}}</span>
                                                      <span class="font-weight-bold" v-else>{{$t('Formularios.ProductoEmpacando')}}</span>
                                                      <br>
                                                      <span v-if="i.producto.enviado">{{$t('Formularios.Guia')}}: {{i.producto.guia}}</span>
                                                    </v-col>
                                                    <v-col cols="12" align="center" v-if="resumenCompra.estado === '4' && i.producto.tipo === 'digital'">
                                                      <v-btn color="primary white--text" large :href="i.producto.archivoDigital" target="_blank">{{$t('Formularios.DescargarProducto')}}</v-btn>
                                                    </v-col>
                                                  </v-row>
                                              </v-container>
                                          </v-card-title>
                                      </v-card>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" v-if="medioDePago === 'paypal' && pagoFinalizado">
                                <v-row>
                                  <v-col cols="12" align="center" class="mb-5">
                                    <h3>{{uidPago}}</h3>
                                    <span>{{resumenCompra.fecha}}</span>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <v-icon v-if="esRegalo" size="46" color="primary">fas fa-gift</v-icon>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6" class="px-5" align="center">
                                      <v-row>
                                          <v-col cols="12">
                                              <h2 class="font-weight-regular">{{$t('Formularios.Comprador')}}</h2>
                                          </v-col>
                                          <v-col cols="12" style="word-break:break-word;">
                                              <span>{{usuario.nombre}}</span>
                                              <br>
                                              <span>{{usuario.tipoDocumento}} {{usuario.documento}}</span>
                                              <br>
                                              <span>{{getPaises[usuario.pais - 1].name}} - {{usuario.departamento}} - {{usuario.ciudad}}</span>
                                              <br>
                                              <span>{{usuario.direccion}} - {{usuario.codigoPostal}}</span>
                                              <br>
                                              <span>{{usuario.email}}</span>
                                              <br>
                                              <span>{{usuario.telefono}}</span>
                                          </v-col>
                                      </v-row>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6" class="px-5" align="center" >
                                    <v-row>
                                        <v-col cols="12">
                                            <h2 class="font-weight-regular">{{$t('Formularios.DireccionEntrega')}}</h2>
                                        </v-col>
                                        <v-col cols="12" style="word-break:break-word;">
                                            <span>{{resumenCompra.direccion.nombre}}</span>
                                            <br>
                                            <span>{{getPaises[resumenCompra.direccion.pais - 1].name}} - {{resumenCompra.direccion.departamento}} - {{resumenCompra.direccion.ciudad}}</span>
                                            <br>
                                            <span>{{resumenCompra.direccion.direccion}} - {{resumenCompra.direccion.codigoPostal}}</span>
                                            <br>
                                            <span>{{resumenCompra.direccion.telefono}}</span>
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <h2 class="font-weight-regular">{{$t('Carrito.Productos')}}</h2>
                                  </v-col>
                                  <v-col cols="12" v-for="i in resumenCompra.productos" :key="i.uid">
                                      <v-card>
                                          <v-card-title>
                                              <v-container>
                                                  <v-row>
                                                      <v-col cols="4" align-self="center">
                                                          <v-img :src="i.imagenPrincipal" />
                                                      </v-col>
                                                      <v-col cols="8" align-self="center">
                                                          <span>{{i.titulo}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Cantidad')}}:</b> {{i.cantidad}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Tipo')}}:</b> {{i.tipo}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Precio')}}:</b> {{i.totalProducto.toLocaleString()}}</span>
                                                          <hr>
                                                          <span><b>{{$t('Formularios.Artista')}}</b></span>
                                                          <br>
                                                          <span>{{i.artista.nombre}}</span>
                                                          <br>
                                                          <span>{{i.artista.email}}</span>
                                                          <br>
                                                          <span>{{i.artista.pais}}</span>
                                                      </v-col>
                                                  </v-row>
                                                  <v-row>
                                                    <v-col cols="12" align="center" v-if="i.tipo === 'fisico'">
                                                      <v-icon color="black" size="42">fas fa-box-open</v-icon>
                                                      <br>
                                                      <span class="font-weight-bold">{{$t('Formularios.ProductoEmpacando')}}</span>
                                                    </v-col>
                                                    <v-col cols="12" align="center" v-if="resumenCompra.estado === '4' && i.tipo === 'digital' || medioDePago === 'paypal' && i.tipo === 'digital'">
                                                      <v-btn color="primary white--text" large :href="i.archivoDigital" target="_blank">{{$t('Formularios.DescargarProducto')}}</v-btn>
                                                    </v-col>
                                                  </v-row>
                                              </v-container>
                                          </v-card-title>
                                      </v-card>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" v-if="medioDePago === 'cupon' && pagoFinalizado">
                                <v-row>
                                  <v-col cols="12" align="center" class="mb-5">
                                    <h3>{{uidPago}}</h3>
                                    <span>{{resumenCompra.fecha}}</span>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <v-icon v-if="esRegalo" size="46" color="primary">fas fa-gift</v-icon>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6" class="px-5" align="center">
                                      <v-row>
                                          <v-col cols="12">
                                              <h2 class="font-weight-regular">{{$t('Formularios.Comprador')}}</h2>
                                          </v-col>
                                          <v-col cols="12" style="word-break:break-word;">
                                              <span>{{usuario.nombre}}</span>
                                              <br>
                                              <span>{{usuario.tipoDocumento}} {{usuario.documento}}</span>
                                              <br>
                                              <span>{{getPaises[usuario.pais - 1].name}} - {{usuario.departamento}} - {{usuario.ciudad}}</span>
                                              <br>
                                              <span>{{usuario.direccion}} - {{usuario.codigoPostal}}</span>
                                              <br>
                                              <span>{{usuario.email}}</span>
                                              <br>
                                              <span>{{usuario.telefono}}</span>
                                          </v-col>
                                      </v-row>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6" class="px-5" align="center" >
                                    <v-row>
                                        <v-col cols="12">
                                            <h2 class="font-weight-regular">{{$t('Formularios.DireccionEntrega')}}</h2>
                                        </v-col>
                                        <v-col cols="12" style="word-break:break-word;">
                                            <span>{{resumenCompra.direccion.nombre}}</span>
                                            <br>
                                            <span>{{getPaises[resumenCompra.direccion.pais - 1].name}} - {{resumenCompra.direccion.departamento}} - {{resumenCompra.direccion.ciudad}}</span>
                                            <br>
                                            <span>{{resumenCompra.direccion.direccion}} - {{resumenCompra.direccion.codigoPostal}}</span>
                                            <br>
                                            <span>{{resumenCompra.direccion.telefono}}</span>
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" align="center">
                                      <h2 class="font-weight-regular">{{$t('Carrito.Productos')}}</h2>
                                  </v-col>
                                  <v-col cols="12" v-for="i in resumenCompra.productos" :key="i.uid">
                                      <v-card>
                                          <v-card-title>
                                              <v-container>
                                                  <v-row>
                                                      <v-col cols="4" align-self="center">
                                                          <v-img :src="i.imagenPrincipal" />
                                                      </v-col>
                                                      <v-col cols="8" align-self="center">
                                                          <span>{{i.titulo}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Cantidad')}}:</b> {{i.cantidad}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Tipo')}}:</b> {{i.tipo}}</span>
                                                          <br>
                                                          <span><b>{{$t('Formularios.Precio')}}:</b> {{i.totalProducto.toLocaleString()}}</span>
                                                          <hr>
                                                          <span><b>{{$t('Formularios.Artista')}}</b></span>
                                                          <br>
                                                          <span>{{i.artista.nombre}}</span>
                                                          <br>
                                                          <span>{{i.artista.email}}</span>
                                                          <br>
                                                          <span>{{i.artista.pais}}</span>
                                                      </v-col>
                                                  </v-row>
                                                  <v-row>
                                                    <v-col cols="12" align="center" v-if="i.tipo === 'fisico'">
                                                      <v-icon color="black" size="42">fas fa-box-open</v-icon>
                                                      <br>
                                                      <span class="font-weight-bold">{{$t('Formularios.ProductoEmpacando')}}</span>
                                                    </v-col>
                                                    <v-col cols="12" align="center" v-if="resumenCompra.estado === '4' && i.tipo === 'digital' || medioDePago === 'paypal' && i.tipo === 'digital'">
                                                      <v-btn color="primary white--text" large :href="i.archivoDigital" target="_blank">{{$t('Formularios.DescargarProducto')}}</v-btn>
                                                    </v-col>
                                                  </v-row>
                                              </v-container>
                                          </v-card-title>
                                      </v-card>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" align="center">
                                <p>{{$t('Carrito.MensajePedido')}}</p>
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn :to="$t('Alias.PedidosPerfil')" color="primary white--text" large>{{$t('Carrito.MisPedidos')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12" align="center" class="pb-0">
                        <span>{{$t('Carrito.MediosDePago')}}</span>
                      </v-col>
                      <div id="app">
                      {{ info }}
                      </div>
                      <!-- <v-col cols="12" align="center">
                        <v-btn color="primary" x-large style="min-width:20%!important" @click="correo" >PRUEBA</v-btn>
                       </v-col> -->
                      <v-col cols="12" align="center" class="pb-2">
                        <v-tooltip bottom color="primary">
                          <template v-slot:activator="{ on }">
                            <v-img v-on="on" :src="PayU" contain max-width="500" height="50" />
                          </template>
                          <span>PayU Latam</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" v-for="i in formasDePago" :key="i.titulo" align="center" class="pb-2">
                        <v-tooltip bottom color="primary">
                          <template v-slot:activator="{ on }">
                            <v-img v-on="on" :src="i.src" contain max-width="500" height="30" />
                          </template>
                          <span>{{i.titulo}}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>
              </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import Paypal from '../assets/paypal.png'
import PayU from '../assets/payu-logo.png'
import TarjetaCredito from '../assets/TarjetaCredito.png'
import Efectivo from '../assets/Efectivo.png'
import Bancos from '../assets/Bancos.png'
import Pse from '../assets/Pse.png'
import visa from '../assets/visa.png'
import mastercard from '../assets/mastercard.png'
import american from '../assets/american.png'
import diners from '../assets/diners.png'
import * as faker from 'faker'
import md5 from 'md5'
import $ from 'jquery'
import axios from 'axios'
// import moment from 'moment'
// import axios from 'vue-axios-cors'

export default {
  name: 'Carrito',
  data () {
    return {
      passwordRules: [
        v => !!v || this.$i18n.t('Formularios.ContrasenaRequerido'),
        v => (v && v.length >= 6) || this.$i18n.t('Formularios.ContrasenaTamano')
      ],
      emailRules: [
        v => !!v || this.$i18n.t('Formularios.EmailRequerido'),
        v => /.+@.+/.test(v) || this.$i18n.t('Formularios.EmailValido')
      ],
      requerido: [v => !!v || this.$i18n.t('Formularios.CampoRequerido')],
      valido: false,
      PayU,
      visa,
      mastercard,
      american,
      diners,
      resumenCompra: null,
      dolar1: null,
      info: null,
      fecha: null,
      mediosDePago: [
        {
          titulo: 'Paypal', src: Paypal, id: 'paypal'
        },
        {
          titulo: 'PayU Latam | Tarjeta Crédito, Débito, PSE, Efectivo', src: PayU, id: 'payu'
        }
      ],
      formasDePago: [
        {
          titulo: 'Pse', src: Pse, id: 'pse'
        },
        {
          titulo: this.$i18n.t('Carrito.TarjetaCredito'), src: TarjetaCredito, id: 'tarjetaCredito'
        },
        {
          titulo: this.$i18n.t('Carrito.Bancos'), src: Bancos, id: 'bancos'
        },
        {
          titulo: this.$i18n.t('Carrito.Efectivo'), src: Efectivo, id: 'efectivo'
        },
        {
          titulo: 'Paypal', src: Paypal, id: 'paypal'
        }
      ],
      tiposDocumento: [
        {
          titulo: this.$i18n.t('PayU.CC'),
          id: 'CC'
        },
        {
          titulo: this.$i18n.t('PayU.CE'),
          id: 'CE'
        },
        {
          titulo: this.$i18n.t('PayU.NIT'),
          id: 'NIT'
        },
        {
          titulo: this.$i18n.t('PayU.TI'),
          id: 'TI'
        },
        {
          titulo: this.$i18n.t('PayU.PP'),
          id: 'PP'
        },
        {
          titulo: this.$i18n.t('PayU.IDC'),
          id: 'IDC'
        },
        {
          titulo: this.$i18n.t('PayU.CEL'),
          id: 'CEL'
        },
        {
          titulo: this.$i18n.t('PayU.RC'),
          id: 'RC'
        },
        {
          titulo: this.$i18n.t('PayU.DE'),
          id: 'DE'
        }
      ],
      paso: 1,
      pasoCompletado: 1,
      codigo: null,
      registro: {
        email: null,
        contrasena: null,
        nombre: null,
        telefono: null,
        newsletter: true
      },
      acceso: {
        email: null,
        contrasena: null
      },
      usuario: null,
      cliente: true,
      descuento: null,
      porcentaje: null,
      cuponPorcentaje: false,
      envio: 0,
      medioDePago: null,
      esRegalo: false,
      regalo: {
        nombre: null,
        telefono: null,
        pais: null,
        departamento: null,
        ciudad: null,
        direccion: null,
        codigoPostal: null
      },
      uidPago: faker.random.alphaNumeric(8).toUpperCase(),
      cargandoPago: false,
      pagoFinalizado: false,
      cupon: false,
      normal: true,
      enrollado: false,
      costosEnvio: false,
      errorEnvio: false,
      productosUsuario: [],
      pagoPayU: null,
      textCorreoEs: null,
      textCorreoEn: null

    }
  },
  mounted () {
    this.fecha = firebase.firestore.Timestamp.now()
    this.dolar1 = this.getDolar
    this.usuario = {
      uid: this.getUsuario.uid,
      nombre: this.getUsuario.nombre,
      email: this.getUsuario.email,
      telefono: this.getUsuario.telefono,
      tipoDocumento: this.getUsuario.tipoDocumento,
      documento: this.getUsuario.numeroDocumento,
      pais: this.getUsuario.pais,
      departamento: this.getUsuario.departamento,
      ciudad: this.getUsuario.ciudad,
      direccion: this.getUsuario.direccion,
      codigoPostal: this.getUsuario.codigoPostal
    }
    if (this.$route.query.message) {
      switch (this.$route.query.message) {
        case 'APPROVED':
          this.uidPago = this.$route.query.referenceCode
          this.medioDePago = 'payu'
          const hoy = new Date()
          const date = new Date().toISOString().slice(0, 10)
          const hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds()
          this.fecha = date + ' ' + hora
          let self = this
          this.subirPedidos('4', this.fecha).then(() => {
            self.limpiarCarrito()
            self.generarPagos()
          })

          break

        case 'PENDING':
          this.setTextoAlerta('Lo sentimos la transacción ha quedado pendiente')
          this.setAlerta()
          break

        case 'DECLINED':
          this.setTextoAlerta('Lo sentimos la transacción ha sido rechazada')
          this.setAlerta()
          break

        default:
          break
      }
    }
  },
  computed: {
    ...mapGetters(['getProductos', 'getTotal', 'getLogeado', 'getSubtotal', 'getPaises', 'getUsuario', 'getMoneda', 'getDolar', 'getCarritoHabilitado', 'getIdioma']),
    granTotal: function () {
      if (this.getMoneda === 'USD') {
        return Number(this.getTotal / this.getDolar) + Number(this.envio)
      } else {
        return Number(this.getTotal) + Number(this.envio)
      }
    },
    granTotalDolar: function () {
      var sum = Math.round((this.getTotal + this.envio) / this.getDolar).toLocaleString()
      return sum
    }
  },
  methods: {
    ...mapMutations(['limpiarCarrito', 'aumentarCantidad', 'disminuirCantidad', 'unSetProducto', 'setDescuento', 'setAlerta', 'setTextoAlerta', 'setPayU', 'setPaypal', 'setDireccionEnvio', 'setProductos']),
    ...mapActions(['iniciarSesion', 'registroCliente', 'enviarCorreo']),
    seccionLlena (pagina) {
      this.paso = pagina
      this.pasoCompletado = pagina
      if (pagina === 2) this.arreglarProductos()
    },
    arreglarProductos () {
      var productos = [...this.getProductos]
      var productosEmail = []
      var productosOrdenados = []
      for (let index in productos) {
        let i = productosEmail.indexOf(productos[index].artista.email)
        if (i === -1) {
          productosEmail.push(productos[index].artista.email)
          productosOrdenados.push(
            {
              email: productos[index].artista.email,
              nombre: productos[index].artista.nombre,
              costoEnvio: 0,
              productos: [productos[index]]
            }
          )
        } else {
          productosOrdenados[i].productos.push(productos[index])
        }
      }
      this.productosEmail = productosOrdenados
    },
    empaqueNormal (index) {
      let data = this.getProductos
      data[index].enrollado = !data[index].normal
    },
    empaqueEnrollado (index) {
      let data = this.getProductos
      data[index].normal = !data[index].enrollado
    },
    async calcularCostosEnvio () {
      let validoEnvios = true
      var costoTotalEnvio = 0
      let productoEmail = this.productosEmail
      for (let index in productoEmail) {
        var costoEnvio = 0
        let codigoPostal = this.usuario.codigoPostal
        let pais = this.usuario.pais

        if (this.esRegalo) {
          codigoPostal = this.regalo.codigoPostal
          pais = this.regalo.pais
        }

        let paisCodigo = this.getPaises[pais - 1].iso2

        let nowTime = new Date().toISOString()
        let time = `<MessageTime>${nowTime}</MessageTime>`
        let to = `<To>
            <CountryCode>${paisCodigo}</CountryCode>
            <Postalcode>${codigoPostal}</Postalcode>
          </To>`
        let accountNumber = paisCodigo === 'CO'
          ? '<PaymentAccountNumber>683147674</PaymentAccountNumber>'
          : '<PaymentAccountNumber>953299964</PaymentAccountNumber>'

        /* let from = `<From>
          <CountryCode>CO</CountryCode>
          <Postalcode>110111</Postalcode>
        </From>` */

        let paymet = `<PaymentCountryCode>CO</PaymentCountryCode>
          <Date>${nowTime.slice(0, 10)}</Date>`
        let pieces = ''
        let from = ''

        var dhlApi = false
        for (let i in productoEmail[index].productos) {
          let producto = productoEmail[index].productos[i]
          if (producto.envioIncluido || producto.tipo === 'digital') {
            break
          } else if (paisCodigo === producto.artista.codigo) {
            costoEnvio += producto.costeEnvio
          } else {
            dhlApi = true
            let listaDatos = producto.enrollado ? producto.dimensionesEnrollado : producto.dimensiones
            pieces += `<Piece>
                    <PieceID>${producto.cantidad}</PieceID>
                    <Height>${listaDatos.altoEmpacado}</Height>
                    <Depth>${listaDatos.anchoEmpacado}</Depth>
                    <Width>${listaDatos.largoEmpacado}</Width>
                    <Weight>${listaDatos.pesoEmpacado / 1000}</Weight>
                </Piece>`
            /* Si son diferentes sitios se generan varias fichas */
            from = `<From>
              <CountryCode>${producto.artista.codigo}</CountryCode>
              <Postalcode>${producto.artista.codigoPostal}</Postalcode>
            </From>`
          }
        }

        if (dhlApi) {
          try {
            // const value = this.getIdioma === 'es' ? 'COP' : 'USD'
            const value = this.getMoneda === 'COP' ? this.getTotal : Math.round(this.getTotal / this.getDolar)
            let response = await this.generarValorDHL(to, from, paymet, time, pieces, accountNumber, value, this.getMoneda)
            if (response) {
              costoEnvio = parseInt(response)
            } else {
              validoEnvios = false
            }
          } catch (err) {
            validoEnvios = false
          }
        }
        productoEmail[index].costoEnvio = costoEnvio
        costoTotalEnvio += costoEnvio
      }
      this.envio = costoTotalEnvio // Costo Total de envio
      this.costosEnvio = true // Habilita la lista de productos, resumen
      this.errorEnvio = !validoEnvios // Mostrar error en la peticion
    },
    aplicarCupon () {
      var infoCodigo = null
      if (this.codigo) {
        firebase.firestore().collection('cupones').doc(this.codigo).get()
          .then(info => {
            if (info.data() === undefined) {
              this.setAlerta()
              this.setTextoAlerta('Alerta.CodigoIncorrecto')
              return
            }
            infoCodigo = info.data()
            this.cupon = true
            if (infoCodigo.cantidad > infoCodigo.usados) {
              if (infoCodigo.porcentaje) {
                this.setDescuento({ tipo: 'porcentaje', valor: infoCodigo.porcentaje })
                this.cuponPorcentaje = true
                this.porcentaje = infoCodigo.porcentaje
              } else {
                this.cuponPorcentaje = false
                this.setDescuento({ tipo: 'valor', valor: infoCodigo.valor })
                this.descuento = infoCodigo.valor
              }
            } else {
              this.setAlerta()
              const mensaje = this.$i18n.t('Carrito.CuponUsado')
              this.setTextoAlerta(mensaje)
            }
          })
          .catch(error => {
            this.setAlerta()
            this.setTextoAlerta(error)
          })
      }
    },
    pagarCupon () {
      this.cargandoPago = true
      firebase.firestore().collection('cupones').doc(this.codigo).update('usados', firebase.firestore.FieldValue.increment(1))
      // CREAR NUEVO CUPÓN
      axios({
        method: 'post',
        url: '/generarCupon',
        crossDomain: true,
        data: {
          nombre: this.usuario.nombre,
          email: this.usuario.email,
          cupon: {
            uid: faker.random.alphaNumeric(12).toUpperCase(),
            cantidad: 1,
            porcentaje: null,
            usados: 0,
            valor: Math.abs(this.granTotal)
          }
        }
      })
      // this.fecha = new Date().toISOString().slice(0, 10)
      const hoy = new Date()
      const date = new Date().toISOString().slice(0, 10)
      const hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds()
      this.fecha = date + ' ' + hora
      this.subirPedidos('4', this.fecha).then(() => {
        axios({
          method: 'post',
          url: '/paypal',
          crossDomain: true,
          data: {
            usuario: this.usuario,
            productos: this.getProductos,
            uidPago: this.uidPago
          }
        })
        this.resumenCompra = {
          productos: this.getProductos
        }
        if (this.esRegalo) {
          this.resumenCompra.direccion = {
            nombre: this.regalo.nombre,
            telefono: this.regalo.telefono,
            pais: this.regalo.pais,
            departamento: this.regalo.departamento,
            ciudad: this.regalo.ciudad,
            direccion: this.regalo.direccion,
            codigoPostal: this.regalo.codigoPostal
          }
        } else {
          this.resumenCompra.direccion = {
            nombre: this.usuario.nombre,
            telefono: this.usuario.telefono,
            pais: this.usuario.pais,
            departamento: this.usuario.departamento,
            ciudad: this.usuario.ciudad,
            direccion: this.usuario.direccion,
            codigoPostal: this.usuario.codigoPostal
          }
        }
        this.resumenCompra.fecha = this.fecha
        this.pagoFinalizado = true
        this.paso = 4
        this.medioDePago = 'cupon'
        this.setAlerta()
        this.setTextoAlerta('Alerta.PagoExitoso')
        this.limpiarCarrito()
      })
    },
    pagarPaypal () {
      window.paypal.Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                description: this.uidPago,
                amount: {
                  currency_code: 'USD',
                  value: this.granTotalDolar
                }
              }
            ]
          })
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture()
          if (order.status === 'COMPLETED') {
            if (this.cupon) {
              firebase.firestore().collection('cupones').doc(this.codigo).update('usados', firebase.firestore.FieldValue.increment(1))
            }
            this.cargandoPago = true
            this.subirPedidos('4', this.fecha).then(() => {
              firebase.firestore().collection('paypal').doc(this.uidPago).set(order).then(() => {
                axios({
                  method: 'post',
                  url: '/paypal',
                  crossDomain: true,
                  data: {
                    usuario: this.usuario,
                    productos: this.getProductos,
                    uidPago: this.uidPago
                  }
                })
                this.resumenCompra = {
                  productos: this.getProductos
                }
                if (this.esRegalo) {
                  this.resumenCompra.direccion = {
                    nombre: this.regalo.nombre,
                    telefono: this.regalo.telefono,
                    pais: this.regalo.pais,
                    departamento: this.regalo.departamento,
                    ciudad: this.regalo.ciudad,
                    direccion: this.regalo.direccion,
                    codigoPostal: this.regalo.codigoPostal
                  }
                } else {
                  this.resumenCompra.direccion = {
                    nombre: this.usuario.nombre,
                    telefono: this.usuario.telefono,
                    pais: this.usuario.pais,
                    departamento: this.usuario.departamento,
                    ciudad: this.usuario.ciudad,
                    direccion: this.usuario.direccion,
                    codigoPostal: this.usuario.codigoPostal
                  }
                }
                this.resumenCompra.fecha = order.update_time
                this.pagoFinalizado = true
                this.paso = 4
                this.setAlerta()
                this.setTextoAlerta('Alerta.PagoExitoso')
                this.limpiarCarrito()
              })
            })
          }
        },
        onError: function (err) {
          this.setAlerta()
          this.setTextoAlerta(err)
        }
      })
        .render(this.$refs.paypal)
    },
    async pagarPayu () {
      firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
        nombre: this.usuario.nombre,
        email: this.usuario.email,
        tipoDocumento: this.usuario.tipoDocumento,
        numeroDocumento: this.usuario.documento,
        telefono: this.usuario.telefono,
        pais: this.usuario.pais,
        departamento: this.usuario.departamento,
        ciudad: this.usuario.ciudad,
        direccion: this.usuario.direccion,
        codigoPostal: this.usuario.codigoPostal
      }).then(() => {
        if (this.getMoneda === 'COP') {
          this.pagoPayU = this.granTotal
        } else {
          this.pagoPayU = this.granTotalDolar
        }
        /*  const payU = {    // PRODUCCIÓN
          apiKey: 'MfO1qCB31JHyDN10KD9049srz8',
          apiLogin: 'eN2OIrNL59j6S9i',
          accountId: '884769',
          merchantId: '877064',
          test: 0,
          url: 'https://gateway.payulatam.com/ppp-web-gateway/'
        } */
        const payU = { // TEST
          apiKey: '4Vj8eK4rloUd272L48hsrarnUA',
          apiLogin: 'pRRXKOl8ikMmt9u',
          accountId: '512321',
          merchantId: '508029',
          test: 0,
          url: 'https://sandbox.checkout.payulatam.com/ppp-web-gateway-payu/'
        }
        var data = {
          merchantId: payU.merchantId,
          accountId: payU.accountId,
          description: 'Pedido ' + this.uidPago,
          referenceCode: this.uidPago,
          amount: this.pagoPayU,
          tax: 0,
          taxReturnBase: 0,
          currency: this.getMoneda,
          signature: md5(payU.apiKey + '~' + payU.merchantId + '~' + this.uidPago + '~' + this.pagoPayU + '~' + this.getMoneda),
          test: payU.test,
          buyerFullName: this.usuario.nombre,
          buyerEmail: this.usuario.email,
          payerFullName: this.usuario.nombre,
          payerDocument: this.usuario.documento,
          payerPhone: this.usuario.telefono,
          mobilePhone: this.usuario.telefono,
          billingAddress: this.usuario.direccion,
          algorithmSignature: 'MD5',
          responseUrl: 'https://trartist.com/carrito',
          confirmationUrl: 'https://us-central1-trartist-com.cloudfunctions.net/api/confirmacion',
          telephone: this.usuario.telefono
        }
        var $form = $('<form>', {
          action: payU.url,
          method: 'post'
        })
        $.each(data, function (key, val) {
          $('<input>').attr({
            type: 'hidden',
            name: key,
            value: val
          }).appendTo($form)
        })
        $form.appendTo('body').submit()
      })
    },
    subirPedidos (estado, fecha) {
      return new Promise((resolve, reject) => {
        let direccion = null
        if (this.esRegalo) {
          direccion = {
            nombre: this.regalo.nombre,
            telefono: this.regalo.telefono,
            pais: this.regalo.pais,
            departamento: this.regalo.departamento,
            ciudad: this.regalo.ciudad,
            direccion: this.regalo.direccion,
            codigoPostal: this.regalo.codigoPostal
          }
        } else {
          this.usuario.telefono = this.usuario.telefono ? this.usuario.telefono : ''
          this.usuario.tipoDocumento = this.usuario.tipoDocumento ? this.usuario.tipoDocumento : ''
          this.usuario.documento = this.usuario.documento ? this.usuario.documento : ''
          this.usuario.pais = this.usuario.pais ? this.usuario.pais : ''
          this.usuario.departamento = this.usuario.departamento ? this.usuario.departamento : ''
          this.usuario.ciudad = this.usuario.ciudad ? this.usuario.ciudad : ''
          this.usuario.direccion = this.usuario.direccion ? this.usuario.direccion : ''
          this.usuario.codigoPostal = this.usuario.codigoPostal ? this.usuario.codigoPostal : ''
          direccion = {
            nombre: this.usuario.nombre,
            telefono: this.usuario.telefono,
            pais: this.usuario.pais,
            departamento: this.usuario.departamento,
            ciudad: this.usuario.ciudad,
            direccion: this.usuario.direccion,
            codigoPostal: this.usuario.codigoPostal
          }
        }
        let infoCorreo = this.getProductos.map((data) => {
          if (data.tipo === 'fisico') {
            firebase.firestore().collection('productos').doc(data.uid).update({
              cantidadFisico: firebase.firestore.FieldValue.increment(-1)
            })
          } else {
            firebase.firestore().collection('productos').doc(data.uid).update({
              cantidadDigital: firebase.firestore.FieldValue.increment(-1)
            })
          }
          return {
            producto: data.titulo,
            costeEnvio: data.costeEnvio,
            totalProducto: data.totalProducto,
            cantidad: data.cantidad,
            tipo: data.tipo,
            TotalPurchase: data.costeEnvio + data.totalProducto
          }
        })
        // INFO CORREO RESUMEN COMPRA
        let text = ''
        for (let i = 0; i < infoCorreo.length; i++) {
          let keys = Object.keys(infoCorreo[i])
          let message = ''
          for (let j = 0; j < keys.length; j++) {
            let key = keys[j]
            let keyCap = key.charAt(0).toUpperCase() + key.slice(1)
            let final = this.$i18n.t('Correo.' + keyCap)
            message += `<span style="font-weight:bold; text-transform: uppercase">${final}</span>` + ': ' + infoCorreo[i][key] + `<br>`
          }
          var hoy = new Date()
          var date = new Date().toISOString().slice(0, 10)
          var hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds()
          var fechaYHora = date + ' ' + hora
          text += `${message}` + `<br>` + `<span style="font-weight:bold; text-transform: uppercase">${this.$i18n.t('Correo.' + 'Date')}: </span>` + `<span>${fechaYHora}</span>` + `<br>`
        }
        for (let i = 0; i < this.getProductos.length; i++) {
          // comprador.telefono = this.usuario.telefono ? this.usuario.telefono : ''
          let info = {
            uid: faker.random.alphaNumeric(10).toUpperCase(),
            uidPago: this.uidPago,
            esRegalo: this.esRegalo,
            comprador: this.usuario,
            direccion: direccion,
            producto: {
              uid: this.getProductos[i].uid,
              titulo: this.getProductos[i].titulo,
              imagenPrincipal: this.getProductos[i].imagenPrincipal,
              cantidad: this.getProductos[i].cantidad,
              tipo: this.getProductos[i].tipo,
              // envioIncluido: this.getProductos[i].envioIncluido,
              enviado: false,
              guia: '',
              transportadora: '',
              talla: this.getProductos[i].talla ? this.getProductos[i].talla : '',
              color: this.getProductos[i].color ? this.getProductos[i].color : '',
              uidInventario: this.getProductos[i].uidInventario,
              referencia: this.getProductos[i].referencia,
              categoria: this.getProductos[i].categoria ? this.getProductos[i].categoria : '',
              totalArtista: this.getProductos[i].totalArtista ? this.getProductos[i].totalArtista : ''
            },
            artista: {
              uid: this.getProductos[i].artista.uid,
              nombre: this.getProductos[i].artista.nombre,
              pais: this.getProductos[i].artista.pais,
              email: this.getProductos[i].artista.email
            },
            total: this.getProductos[i].totalProducto,
            estado: estado || null,
            fecha: fecha || null
          }
          if (this.getProductos[i].tipo === 'digital') {
            info.producto.enviado = true
            info.producto.archivoDigital = this.getProductos[i].archivoDigital
          }
          firebase.firestore().collection('pedidos').doc(info.uid).set(info)
            .then(() => {
              if (i === (this.getProductos.length - 1)) {
                resolve(true)
              }
              // ENVIAR CORREO INFO RESUMEN COMPRA COMPRADOR
              if (this.getProductos[i].tipo === 'digital') {
                this.textCorreoEs = `<span>Hola, ` + `<span style="font-weight:bold; text-transform: uppercase">${this.usuario.nombre}</span>` + ` Puedes descargar el producto digital comprado en tu perfil en la sección de pedidos.</>` + `<br>` + `<br>` + `<span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
                this.textCorreoEn = `<span>Hello, ` + `<span style="font-weight:bold; text-transform: uppercase">${this.usuario.nombre}</span>` + ` You can download the purchased digital product in your profile in the order section.</>` + `<br>` + `<br>` + `<span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
              } else {
                this.textCorreoEs = `<span>Hola, ` + `<span style="font-weight:bold; text-transform: uppercase">${this.usuario.nombre}</span>` + ` El resumen de su compra es:</>` + `<br>` + `<br>` + text + `<br>` + `<span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
                this.textCorreoEn = `<span>Hello, ` + `<span style="font-weight:bold; text-transform: uppercase">${this.usuario.nombre}</span>` + ` The summary of your purchase is:</>` + `<br>` + `<br>` + text + `<br>` + `<span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
              }
              // TEXT EMAIL VENDEDOR
              let textCorreoEsVendedor = `<span>Hola, </>` + `<span style="font-weight:bold; text-transform: uppercase">${info.artista.nombre}</span>` + `<br>` + `Tu producto` + `<span style="font-weight:bold; text-transform: uppercase">${info.producto.titulo}</span>` + ` se ha vendido. Ingresa a tu backoffice para conocer todos los detalles.` + `<br>` + `<br>` + `Recuerda tener en cuenta todas las recomendaciones que te damos en las capacitaciones.` + `<br>` + `<span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
              let textCorreoEnVendedor = `<span>Hello, </>` + `<span style="font-weight:bold; text-transform: uppercase">${info.artista.nombre}</span>` + `<br>` + `Your product ` + `<span style="font-weight:bold; text-transform: uppercase">${info.producto.titulo}</span>` + ` has been sold. Enter your backoffice to know all the details.` + `<br>` + `<br>` + `Remember to take into account all the recommendations we give you in the training.` + `<br>` + `<br>` + `<span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
              if (this.getIdioma === 'es') {
                this.enviarCorreo({
                  destino: this.usuario.email,
                  asunto: this.$i18n.t('Email.AsuntoVentasProducto'),
                  texto: this.textCorreoEs
                })
                this.enviarCorreo({
                  destino: info.artista.email,
                  asunto: 'Tu producto ' + info.producto.titulo + ' se ha vendido',
                  texto: textCorreoEsVendedor
                })
              } else {
                this.enviarCorreo({
                  destino: this.usuario.email,
                  asunto: this.$i18n.t('Email.AsuntoVentasProducto'),
                  texto: this.textCorreoEn
                })
                this.enviarCorreo({
                  destino: info.artista.email,
                  asunto: 'Your product ' + info.producto.titulo + ' has been sold',
                  texto: textCorreoEnVendedor
                })
              }
            })
        }
      })
    },
    generarPagos () {
      firebase.firestore().collection('pedidos').where('uidPago', '==', this.uidPago).get().then(info => {
        let pedidos = []
        for (let i = 0; i < info.docs.length; i++) {
          pedidos.push(info.docs[i].data())
          if (i === (info.docs.length - 1)) {
            this.resumenCompra = Object.values(pedidos.reduce((result, {
              artista,
              comprador,
              direccion,
              esRegalo,
              estado,
              fecha,
              producto,
              total,
              uid,
              uidPago
            }) => {
              // Create new group
              if (!result[uidPago]) {
                result[uidPago] = {
                  uidPago,
                  comprador,
                  direccion,
                  esRegalo,
                  estado,
                  fecha,
                  productos: []
                }
              }
              // Append to group
              result[uidPago].productos.push({
                uid,
                artista,
                producto,
                total
              })
              return result
            }, {}))
          }
        }
      })
      this.pagoFinalizado = true
      this.paso = 4
    },
    async generarValorDHL (to, from, paymet, time, pieces, accountNumber, value, currency) {
      return fetch('https://trartist-proxyserver.herokuapp.com/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ time, from, paymet, pieces, accountNumber, to, value, currency })
      })
        .then(data => {
          return data.json().then(data => {
            const parser = new DOMParser()
            const xmlDoc = parser.parseFromString(data, 'text/xml')
            const qtdSInAdCur = xmlDoc.getElementsByTagName('QtdSInAdCur')
            // VALIDAR QUE LLEGUE TOTAL ENVIO
            if (qtdSInAdCur.length > 2) {
              const value = this.getMoneda === 'COP' ? qtdSInAdCur[1].getElementsByTagName('TotalAmount')[0].innerHTML : qtdSInAdCur[0].getElementsByTagName('TotalAmount')[0].innerHTML
              // VERIFICAR SI EXISTE VALUE
              if (value && value !== '') {
                // TODO: VALIDAR CUANDO NO LLEGAN LOS VALORES DE SHIPPING Y SEGURO
                const qtdShpExChrg = xmlDoc.getElementsByTagName('QtdShpExChrg')
                if (qtdShpExChrg.length > 2) {
                  const qtdSExtrChrgInAdCur = qtdShpExChrg[2].getElementsByTagName('QtdSExtrChrgInAdCur')
                  if (qtdSExtrChrgInAdCur.length > 2) {
                    const specialService = this.getMoneda === 'COP' ? qtdSExtrChrgInAdCur[1].getElementsByTagName('ChargeValue')[0].innerHTML : qtdSExtrChrgInAdCur[0].getElementsByTagName('ChargeValue')[0].innerHTML
                    return (parseFloat(value) + parseFloat(specialService))
                  }
                }
              }
            }
            return 0
          })
        })
        .catch(error => {
          console.log('Error DHL: ', error)
          return 0
        })
    }
  },
  watch: {
    getMoneda () {
      this.calcularCostosEnvio()
    },
    medioDePago (nuevo, viejo) {
      if (nuevo === 'paypal') {
        const script = document.createElement('script')
        script.src = 'https://www.paypal.com/sdk/js?client-id=AaCae-z2vvPQB_X0uE4wsFixabHB1Z12dthlFoBLK1LyHNid7c3j9ECmAQI78GtS_38HUTVuOeJkKKDM'
        script.addEventListener('load', this.pagarPaypal)
        document.body.appendChild(script)
      }
    },
    getLogeado (nuevo, viejo) {
      if (nuevo === true) {
        this.usuario = {
          uid: this.getUsuario.uid,
          nombre: this.getUsuario.nombre,
          email: this.getUsuario.email,
          telefono: this.getUsuario.telefono,
          tipoDocumento: this.getUsuario.tipoDocumento,
          documento: this.getUsuario.documento,
          pais: this.getUsuario.pais,
          departamento: this.getUsuario.departamento,
          ciudad: this.getUsuario.ciudad,
          direccion: this.getUsuario.direccion,
          codigoPostal: this.getUsuario.codigoPostal
        }
      }
    },
    paso (nuevo, viejo) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    pagoFinalizado (nuevo, viejo) {
      if (nuevo) {
        this.cargandoPago = false
        this.paso = 4
      }
    }
  }
}
</script>
